"use client";
import React from "react";
import { SnackbarProvider } from "notistack";

const NotiStackProvider = ({ children }) => {
  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotiStackProvider;
